export { default } from './NarrativeDialog';